import { sanitizeInput } from '../utils';

import {
	type ConfluenceSearchSpaceResult,
	type CrossProductSearchSpaceResult,
	CrossProductSearchSpaceResultV2,
} from './types';
import { AGG_CONFLUENCE_SPACE_SEARCH_URL, getSearchConfluenceSpacesGraphqlPayload } from './utils';

const CONFLUENCE_SPACE_SEARCH_URL = `/gateway/api/xpsearch-aggregator/quicksearch/v1`;

/*
 *  Remove when cleaning up link-create-search-confluence-spaces-gql feature gate, use searchConfluenceSpacesV2 instead
 */
export const searchConfluenceSpaces = async ({
	searchString,
	cloudId,
	limit,
	gatewayBaseUrl = '',
}: {
	searchString?: string;
	cloudId: string;
	limit: number;
	gatewayBaseUrl?: string;
}): Promise<CrossProductSearchSpaceResult> => {
	const query = searchString ? sanitizeInput(searchString) : '';
	const response = await fetch(`${gatewayBaseUrl}${CONFLUENCE_SPACE_SEARCH_URL}`, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query,
			cloudId,
			limit,
			scopes: ['confluence.space'],
			experience: 'link-create.confluence-form',
		}),
	});

	if (!response.ok) {
		throw response;
	}

	return response.json();
};

export const searchConfluenceSpacesV2 = async ({
	searchString,
	cloudId,
	limit,
	gatewayBaseUrl = '',
}: {
	searchString?: string;
	cloudId: string;
	limit: number;
	gatewayBaseUrl?: string;
}): Promise<CrossProductSearchSpaceResultV2> => {
	const queryString = searchString ? sanitizeInput(searchString) : '';
	const response = await fetch(`${gatewayBaseUrl}${AGG_CONFLUENCE_SPACE_SEARCH_URL}`, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: getSearchConfluenceSpacesGraphqlPayload({
			cloudId,
			queryString,
			limit,
		}),
	});

	if (!response.ok) {
		throw response;
	}

	return response.json();
};

/**
 * Search Confluence Space by Id
 * API doc at: https://developer.atlassian.com/cloud/confluence/rest/v2/api-group-space/#api-spaces-id-get
 */
export const searchConfluenceSpace = async ({
	cloudId,
	defaultSpaceId,
	gatewayBaseUrl = '',
}: {
	cloudId: string;
	defaultSpaceId: string;
	gatewayBaseUrl?: string;
}): Promise<ConfluenceSearchSpaceResult> => {
	const response = await fetch(
		`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/spaces/${defaultSpaceId}?${new URLSearchParams(
			{ expand: 'links', description: 'plain', 'include-icon': 'true' },
		).toString()}`,
		{
			method: 'GET',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	if (!response.ok) {
		throw response;
	}

	return response.json();
};
